import { createAction, props } from '@ngrx/store';
import { Campaign } from '@core/models/campaign.model';
import { CampaignFilters } from '@core/services/facades/campaign.facade';

// Load campaigns
export const loadCampaigns = createAction('[Campaign List] Load Campaigns');

export const loadCampaignsSuccess = createAction('[Campaign API] Load Campaigns Success', props<{ pages: { page: number; data: Campaign[] }[] }>());

export const loadCampaignsFailure = createAction('[Campaign API] Load Campaigns Failure', props<{ error: string }>());

// Load single campaign
export const loadCampaign = createAction('[Campaign Detail] Load Campaign', props<{ id: string }>());

export const loadCampaignSuccess = createAction('[Campaign API] Load Campaign Success', props<{ campaign: Campaign }>());

export const loadCampaignFailure = createAction('[Campaign API] Load Campaign Failure', props<{ error: string }>());

// Filters
export const setFilters = createAction('[Campaign List] Set Filters', props<{ filters: CampaignFilters }>());

export const clearFilters = createAction('[Campaign List] Clear Filters');

export const searchCampaigns = createAction('[Campaign List] Search Campaigns', props<{ searchTerm: string }>());

export const invalidateCampaigns = createAction('[Campaign List] Invalidate Campaigns');

// Pagination (how many pages are currently displayed)
export const showNextCampaignsPage = createAction('[Campaign List] Show Next Campaigns Page');

// Scroll position of the list, saved before navigating to a campaign's detail page
export const setCampaignListScrollPosition = createAction('[Campaign List] Set Scroll Position', props<{ position: number }>());

export const resetCampaigns = createAction('[Campaign List] Reset Campaigns');
